var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-titles',[_c('h1',{staticClass:"title h2"},[_vm._v("Métriques mensuel")]),_c('b-card',{attrs:{"no-body":""}},[_c('b-table',{attrs:{"hover":"","items":_vm.metrics,"fields":_vm.fields}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }